import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {externalLinkTypes} from '@/consts/externalLinkTypes';
import log from '@/services/logger/log';
import serviceWorkerService from '@/services/serviceWorkerService';
import {setSwMessage} from '@/state/slices/globalSlice';

const useSWMessage = () => {
    const dispatch = useDispatch();
    const subscribeOnMessage = async () => {
        try {
            await serviceWorkerService.registerServiceWorker();

            const broadcastChannel = new BroadcastChannel('iqos-pwa-sw-channel');

            broadcastChannel.addEventListener('message', (event) => {
                log.debug(`The service worker sent me a message: ${event.data}`);
                try {
                    const data = JSON.parse(event.data);

                    if (data.actionTypeCode) {
                        data.actionTypeCode = externalLinkTypes.normalizeActionTypeCode(data.actionTypeCode);
                    }

                    dispatch(setSwMessage(data));
                } catch (e) {
                    log.error(`On service worker message error: ${JSON.stringify(e)}`);
                }
            });

            serviceWorkerService.sendOpenedMessage();

            log.debug('On service worker post message subscribed');
        } catch (e) {
            log.debug(`useSWMessage, error: ${JSON.stringify(e)}`);
        }
    };

    useEffect(() => {
        subscribeOnMessage();
    }, []);
};

export default useSWMessage;
